var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconswebp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333334 0 0 1.3333334 0 0)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGaSURBVEhLxVXdbcIwEM4IHYERLOJIPGaEyC5SHzsCG5RN+oQc+hI2SDdgBNigI7T3Xc+JE4vaQUj9JItwP9+dnc+X4l+h3pundWt2urVd2doL/X5jyXO/duZVuWYl4fkAsT6at/JovzzprVW25oJ4SU1DuZdV2K125hOdboJOq4+tqshG/hP8Ymb4fBQW04iQvKIA7Z5rcWVhni/mEaPTnusl2ybMycMdM3Dm3vlwcgTAiRU5E0iSA3iJXMDZk5iykEUOUEDPQVRITElkkwOls1cOPGyVmAaAhLUeEKTIpeFO/rKBz1/+TkCKYiJfJKfziC8yBNgQYVgk51giPn9EtxLCIily3HLETG4yGU4wQk1iiuCLpF7oqMhghOjfiYnuejHdDd/sRJGqw/SUyblw/oSAAKTR+LhpS3s4WC0LRwWAHC8AanIv5hHYRfAiz0uK8PeDcpCLdyTmGHNJ5nyttGvqHOkOmEuSVgdlVIdmuOUgEbXwiMHKIg+Bc/TJfy6Ig2KXjngG7wadkqb9ZcSSZ5Kj2d1F/DgUxQ94xaImLao8SgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    width: 18,
    height: 18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconswebp);
export default __webpack_public_path__ + "static/media/Icons.webp.07f1521b7ac2bf07bb979a8a803036c4.svg";
export { ForwardRef as ReactComponent };